import { times } from "lodash-es"
import { ProductCategoryProductsSkeleton } from "../ProductCategoryProducts"
import s from "./ProductCategories.module.scss"

export const ProductCategoriesSkeleton = ({ count }: { count: number }) => {
  return times(count, (index) => <ProductCategoryLoading key={index} />)
}

const ProductCategoryLoading = () => {
  return (
    <div className={s.skeleton}>
      <div className={s.skeleton__title} />
      <ProductCategoryProductsSkeleton count={6} />
    </div>
  )
}
